/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import * as React from 'react';
import LoadingModal from '../modals/LoadingModal';
import { useViewingContext } from '../../contexts/ViewingContext';
import { useLoanInformationContext } from '../../contexts/LoanInformationContext';
import ServicerLoanInformation from '../loan-information/ServicerLoanInformation';
import BorrowerLoanInformation from '../loan-information/BorrowerLoanInformation';
import { useNavigate } from 'react-router-dom';
import useGetCompany from '../../common/hooks/useGetCompany';
import useGetComment from '../../common/hooks/useGetComment';
import { isAfter9AMPTOnJuly1st2026AndBefore9PMPTOnJuly2nd2026, isStrEmptyOrNull } from '../../common/UtilityFunctions';
import { useAuthContext } from '../../contexts/AuthContext';

function LoanInformationForm() {
  const { isServicerView } = useViewingContext();
  const { userId, servicerUser } = useAuthContext();
  const { loading, loanData, servicingData } = useLoanInformationContext();
  const navigate = useNavigate();
  const { companyDetails: companyResp, loadingCompanyDetails: loadingComp } = useGetCompany('GNMA00000');
  const { comment: commentResp, loadingComment: loadingComment } = useGetComment(
    companyResp && companyResp.comment ? companyResp.comment : '',
  );

  if (loading || loadingComp || loadingComment) return <LoadingModal open />;
  if (
    !loading &&
    !loadingComp &&
    !loadingComment &&
    loanData &&
    servicingData &&
    ['331', '332', '333'].includes(servicingData.investorCode) &&
    commentResp &&
    companyResp &&
    !isStrEmptyOrNull(commentResp.comment) &&
    isAfter9AMPTOnJuly1st2026AndBefore9PMPTOnJuly2nd2026() &&
    !(
      servicerUser &&
      [
        '7SK8',
        '5AD8',
        '4TB4',
        '4ME4',
        'AP4E',
        'L8VZ',
        '8SS6',
        '5LS5',
        '4RNA',
        '5RP6',
        '4US4',
        'S8MC',
        'NJ4B',
        'IGNR',
        '4SM1',
        '4AA6',
        'RP8Z',
      ].includes(userId)
    )
  ) {
    window.open(process.env.REACT_APP_DOWNTIME, '_blank');
    navigate('/select-loans');
  }

  if (isServicerView) {
    /* When user is servicer, return this view */
    return <ServicerLoanInformation></ServicerLoanInformation>;
  }
  /* When user is borrower, return this view */
  return <BorrowerLoanInformation></BorrowerLoanInformation>;
}

export default LoanInformationForm;
